{
  "es": {
    "form": {
      "actions": {
        "cancel": "Cancelar",
        "clear": "Limpiar",
        "closeFullPage": "Cerrar página completa",
        "copyText": "Haz clic para copiar el texto",
        "create_and_attach_phase": "Crear y vincular a la fase",
        "create_and_send": "Crear y enviar",
        "create_and_send_to_customer": "Crear y enviar al cliente",
        "create_and_share": "Crear y compartir con el cliente",
        "create_and_share_partners_only": "Crear y compartir con colaborador(es)",
        "create_and_share_with_partners": "Crear y compartir con el cliente y colaborador(es)",
        "next": "Siguiente",
        "only_create": "Solo crear",
        "openFullPage": "Abrir en página completa",
        "save": "Guardar",
        "saveChanges": "Guardar cambios",
        "save_as_draft": "Guardar como borrador",
        "search": "Buscar...",
        "send": "Enviar",
        "send_and_create_another": "Enviar y crear otro",
        "send_to_customer": "Enviar al cliente",
        "share_with_customer": "Compartir con el cliente",
        "submit": "Guardar",
        "submit_and_create_another": "Guardar y crear otro"
      },
      "back": "Paso anterior",
      "labels": {
        "columns": "Columnas",
        "from": "Desde",
        "no_results": "Sin resultados",
        "optional": "(opcional)",
        "to": "Hasta"
      },
      "notifications": {
        "textHasBeenCopied": "El texto se ha copiado"
      },
      "password": "Contraseña",
      "send_moment": {
        "attach_failed": "Creado, pero no vinculado a la fase. Vincúlalo de nuevo en el flujo de trabajo.",
        "concept_description": "Nadie ve nada. Lo envías tú más tarde, o lo vinculas a una fase después.",
        "concept_title": "Guardar como borrador",
        "item_decision": "esta decisión",
        "item_survey": "esta encuesta",
        "item_todo": "esta tarea",
        "now_description_decision": "Los clientes de las unidades seleccionadas reciben la decisión de inmediato, con una notificación.",
        "now_description_survey": "Los clientes de las unidades seleccionadas reciben la encuesta de inmediato, con una notificación.",
        "now_description_todo": "Los responsables de las unidades seleccionadas reciben la tarea de inmediato, con una notificación.",
        "now_title": "Enviar ahora",
        "phase_description": "Se envía sola para cada unidad en cuanto esa unidad llega a la fase.",
        "phase_label": "Fase",
        "phase_title": "Vincular a una fase",
        "title": "¿Cuándo verá el cliente {item}?",
        "workflow_help": "¿Qué es un flujo de trabajo?",
        "workflow_help_more": "Leer más",
        "workflow_help_text": "Un flujo de trabajo son las fases por las que pasa cada unidad. Si vinculas algo a una fase, el cliente lo ve automáticamente en cuanto su unidad llega a esa fase."
      },
      "shortcuts": {
        "save_mac": "⌘ + Intro para guardar",
        "save_windows": "Ctrl + Intro para guardar",
        "send_mac": "⌘ + Intro para enviar",
        "send_windows": "Ctrl + Intro para enviar"
      },
      "steps": "Paso {count} de {total}",
      "writeEmployeeNameReject": "Escribe <i><b>{employeeName}</b></i> para continuar."
    }
  }
}
